import { createFileRoute } from '@tanstack/react-router'
import { ReportsHome } from '../features/reports'
import { catalogueQuery } from '../features/reports/api'

export const Route = createFileRoute('/reports/')({
  // Warm the catalogue; a failed read is the screen's banner, never a route error.
  loader: ({ context }) => void context.queryClient.prefetchQuery(catalogueQuery()),
  component: ReportsHome,
})
